import { createContext, useState } from 'react';

export const CartContext = createContext(null);

export const CartContextProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  const addItem = (product) => {
    const alreadyFound = items.find((i) => i.id === product.id || i.uuid === product.uuid);
    
    if (alreadyFound) {
      incrementItem(product);
    } else {
      setItems([
        ...items,
        {
          id: product.id,
          uuid: product.uuid,
          name: product.name,
          count: 1,
          amount: product.discounted_price,
          originalPrice: product.price,
          image: product.primary_image,
          sku: product.sku,
          product_id: product.id,
        },
      ]);
    }
  };

  const removeItem = (product) => {
    const newItems = items.filter((i) => i.id !== product.id && i.uuid !== product.uuid);
    setItems(newItems);
  };

  const incrementItem = (product) => {
    const newItems = [...items];
    const productId = product.id || product.uuid;
    const index = newItems.findIndex((i) => i.id === productId || i.uuid === productId);
    
    if (index !== -1) {
      newItems[index] = { ...newItems[index] };
      newItems[index].count++;
      setItems(newItems);
    }
  };

  const decrementItem = (product) => {
    const newItems = [...items];
    const productId = product.id || product.uuid;
    const index = newItems.findIndex((i) => i.id === productId || i.uuid === productId);
    
    if (index !== -1) {
      newItems[index] = { ...newItems[index] };
      newItems[index].count--;
      
      if (newItems[index].count <= 0) {
        setItems(newItems.filter((i) => i.id !== productId && i.uuid !== productId));
      } else {
        setItems(newItems);
      }
    }
  };

  const getTotalCount = () => {
    let total = 0;
    items.forEach((i) => (total += i.count));
    return total;
  };

  const getTotalAmount = () => {
    let total = 0;
    items.forEach((i) => (total += i.amount * i.count));
    return total;
  };

  return (
    <CartContext.Provider
      value={{
        items,
        setItems,
        addItem,
        incrementItem,
        decrementItem,
        removeItem,
        getTotalCount,
        getTotalAmount,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartContext;
